<template lang="pug">
  .product-item(:class="`product-style-${type}`")
    .product-body
      h4.product-title
        a(
          :href="item.link"
          target="_blank"
        ) {{ item.title }}

      .product-info(v-if="type === 'default'")
        ul
          li(v-if="item.info.passenger") Passengers :  {{ item.info.passenger }}
          li(v-if="item.info.length") Dimension :  L{{ item.info.length }} x W{{ item.info.width }} x H{{ item.info.height }} Cm
      product-price(
        v-if="item.price.price"
        :price="item.price"
      )
    a.product-image(
      :href="item.link"
      target="_blank"
    )
      img(:src="item.image_url")
        
</template>

<script>
import ProductPrice from './ProductPrice.vue'

export default {
  components: { ProductPrice },

  props: {
    item: {
      type: Object,
      default: () => {}
    },

    type: {
      type: String,
      default: 'default',
    }
  }
}
</script>


